<script>
    import { slide } from 'svelte/transition'

    export let color

    let expanded = false
    function toggleExpanded () {
        expanded = !expanded
    }
</script>

<slot name="visible" />
<div class="revealMore" style="--pageColor: {color}" on:click={toggleExpanded}>
    <slot name="label" />
    <svg
        class="indicator"
        style="transform: {expanded ? 'rotate(90deg)' : ''}"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 240.58 393.15"
    >
        <polygon points="240.58 196.58 0 393.15 0 0 240.58 196.58" />
    </svg>
</div>
{#if expanded}
    <div in:slide out:slide>
        <slot name="hidden" />
    </div>
{/if}

<style lang="scss">
    .revealMore {
        display: flex;
        align-items: center;
        gap: 5px;

        &:hover {
            cursor: pointer;
        }

        svg {
            display: inline;
            max-height: 10px;
            max-width: 10px;
            transition: transform 0.4s ease;
            fill: var(--pageColor);
        }
    }
</style>
